export const version = 'v2.2.4-1719-g09da2b29'
